class SearchInputController {
  constructor() {
    this.name = 'searchInput';
  }
}

export default SearchInputController;
